export default __webpack_public_path__ + "static/media/ico_10.fc0c63b0.png";